import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import UiIcon from 'ui-components/ui-icon/UiIcon';
import MediaGallery from 'components/media-gallery/MediaGallery';
import { StyledInlineGallery } from './InlineGallery.styles';

const InlineGallery = ({ media }) => {
  const { t } = useTranslation();
  const _media = [];
  if (media)
    media.forEach((element) => {
      _media.push({
        original: element,
        thumbnail: element,
      });
    });

  return (
    <StyledInlineGallery>
      <div className='inline-image-gallery'>
        <label className='label'>{t('content:contentGallery')}</label>
        <MediaGallery title={t('content:gallery')} media={_media}>
          {(setVisible) => (
            <div
              className='container flex'
              onClick={() => {
                setVisible((x) => !x);
              }}
            >
              {media?.map((item, index) => {
                return (
                  <div
                    className='image'
                    key={`img${index}`}
                    style={{
                      backgroundImage: `url(${
                        typeof item === 'string' ? item : item?.poster
                      }), url(/assets/img/no-pic.png)`,
                    }}
                  />
                );
              })}
              <span className='more flex'>
                <UiIcon icon='ri-more-2-fill' />
              </span>
            </div>
          )}
        </MediaGallery>
      </div>
    </StyledInlineGallery>
  );
};

InlineGallery.propTypes = {
  media: PropTypes.array,
};

export default InlineGallery;
